(() => {
  function initReviews(root) {
    const search = root.querySelector('[data-review-search]');
    const category = root.querySelector('[data-review-category]');
    const media = root.querySelector('[data-review-media]');
    const stories = [...root.querySelectorAll('[data-review-story]')];
    const empty = root.querySelector('[data-review-empty]');
    const status = root.querySelector('[data-review-status]');
    if (!search || !category || !media || !stories.length || root.dataset.reviewsReady) return;
    root.dataset.reviewsReady = 'true';

    function filterStories() {
      const query = search.value.trim().toLocaleLowerCase();
      let visible = 0;
      for (const story of stories) {
        const matches = (!query || story.textContent.toLocaleLowerCase().includes(query)) &&
          (category.value === 'all' || story.dataset.category === category.value) &&
          (!media.checked || story.dataset.hasMedia === 'true');
        story.hidden = !matches;
        if (matches) visible += 1;
      }
      empty.hidden = visible !== 0;
      status.textContent = `${visible} reference ${visible === 1 ? 'story' : 'stories'} shown`;
    }

    search.addEventListener('input', filterStories);
    category.addEventListener('change', filterStories);
    media.addEventListener('change', filterStories);
    filterStories();
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-nx-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
